var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrap"},[_c('img',{staticClass:"left-arrow",attrs:{"src":require("@/assets/images/my-wallet/ic_left_black.png")},on:{"click":_vm.goback}}),_c('h3',[_vm._v(_vm._s(_vm.title))])])
}
var staticRenderFns = []

export { render, staticRenderFns }